// extracted by mini-css-extract-plugin
export var barContainer = "_3x-0";
export var extraThin = "_3x-3";
export var fillBar = "_3x-6";
export var fillContainer = "_3x-4";
export var overflow = "_3x-8";
export var overflowContainer = "_3x-5";
export var regular = "_3x-7";
export var thick = "_3x-1";
export var thin = "_3x-2";